import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import { getName, getStreamLink } from '../../helpers/Crew';
import { getAvatarUrl } from '../../helpers/User';

const Player = ({ player }) => {
	return <div className="episode-player my-3">
		<Button
			className="player-link"
			href={getStreamLink(player)}
			rel="noreferrer"
			target="_blank"
			variant="outline-twitch"
		>
			<img alt="" src={getAvatarUrl(player.user)} />
			<span className="text-light fs-5 fs-md-4">{getName(player)}</span>
		</Button>
	</div>;
};

Player.propTypes = {
	player: PropTypes.shape({
		id: PropTypes.number,
		name_override: PropTypes.string,
		stream_override: PropTypes.string,
		user: PropTypes.shape({
		}),
	}),
};

export default Player;
